import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";

import LoadingScreen from "../shared/ui/loading/LoadingScreen";
import GuestLayout from "../shared/layouts/guest/GuestLayout";
import { ROUTES } from "../core/config";
import { authRoute } from "../shared/utils/router";

const LoginPage = lazy(() => import("../features/auth/pages/LoginPage"));
const RegisterPage = lazy(() => import("../features/auth/pages/RegisterPage"));
const ForgotPasswordPage = lazy(
  () => import("../features/auth/pages/ForgotPasswordPage")
);
const ResetPasswordPage = lazy(
  () => import("../features/auth/pages/ResetPasswordPage")
);
const VerifyCodePage = lazy(
  () => import("../features/auth/pages/VerifyCodePage")
);

const AuthRoutes = () => {
  return (
    <Suspense fallback={<LoadingScreen text="Connexion sécurisée..." />}>
      <Routes>
        <Route element={<GuestLayout />}>
          <Route
            path={authRoute(ROUTES.AUTH_ROUTES.LOGIN)}
            element={<LoginPage />}
          />

          <Route
            path={authRoute(ROUTES.AUTH_ROUTES.REGISTER)}
            element={<RegisterPage />}
          />

          <Route
            path={authRoute(ROUTES.AUTH_ROUTES.FORGOT_PASSWORD)}
            element={<ForgotPasswordPage />}
          />

          <Route
            path={authRoute(ROUTES.AUTH_ROUTES.RESET_PASSWORD)}
            element={<ResetPasswordPage />}
          />

          <Route
            path={authRoute(ROUTES.AUTH_ROUTES.VERIFY_CODE)}
            element={<VerifyCodePage />}
          />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AuthRoutes;